// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentStatus } from './AssignmentStatus';
import {
  AssignmentStatusFromJSON,
  AssignmentStatusFromJSONTyped,
  AssignmentStatusToJSON,
  AssignmentStatusToJSONTyped,
} from './AssignmentStatus';

/**
 *
 * @export
 * @interface ServiceConfigResponse
 */
export interface ServiceConfigResponse {
  /**
   *
   * @type {AssignmentStatus}
   * @memberof ServiceConfigResponse
   */
  status: AssignmentStatus;
  /**
   *
   * @type {string}
   * @memberof ServiceConfigResponse
   */
  serviceName?: string;
}

/**
 * Check if a given object implements the ServiceConfigResponse interface.
 */
export function instanceOfServiceConfigResponse(
  value: object,
): value is ServiceConfigResponse {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function ServiceConfigResponseFromJSON(
  json: any,
): ServiceConfigResponse {
  return ServiceConfigResponseFromJSONTyped(json, false);
}

export function ServiceConfigResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceConfigResponse {
  if (json == null) {
    return json;
  }
  return {
    status: AssignmentStatusFromJSON(json['status']),
    serviceName:
      json['service_name'] == null ? undefined : json['service_name'],
  };
}

export function ServiceConfigResponseToJSON(json: any): ServiceConfigResponse {
  return ServiceConfigResponseToJSONTyped(json, false);
}

export function ServiceConfigResponseToJSONTyped(
  value?: ServiceConfigResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    status: AssignmentStatusToJSON(value['status']),
    service_name: value['serviceName'],
  };
}
